import { render, staticRenderFns } from "./OpeningSupplier.vue?vue&type=template&id=0dc418de&scoped=true"
import script from "./OpeningSupplier.vue?vue&type=script&lang=js"
export * from "./OpeningSupplier.vue?vue&type=script&lang=js"
import style0 from "./OpeningSupplier.vue?vue&type=style&index=0&id=0dc418de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc418de",
  null
  
)

export default component.exports